module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('panel-header', {
    attrs: {
      "title": this.title,
      "toggle-button-value": _vm.filterShow
    },
    on: {
      "toggleFilterPanel": _vm.toggleFilterPanel
    }
  }), _vm._v(" "), (_vm.filterShow) ? _c('toggle-filter-panel', {
    attrs: {
      "filters": _vm.availableFilters,
      "pagination-filter": _vm.defaultFilter
    },
    on: {
      "filterChange": _vm.filterChange,
      "defaultFilterChange": _vm.defaultFilterChange
    }
  }) : _vm._e(), _vm._v(" "), (_vm.filterShow) ? _c('br') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "bg"
  }, [_c('div', {
    staticClass: "inner clearfix"
  }, [_c('data-table', {
    attrs: {
      "dt-id": _vm.route.name + (_vm.type ? '-' + _vm.type : ''),
      "my-ajax": _vm.dataTableAjax,
      "columns": _vm.columns,
      "column-defs": _vm.columnDefs,
      "refresh": _vm.DTRefresh,
      "on-click-element": ".row-details",
      "on-click-element-event": _vm.onClickEvent,
      "search": {
        handle: '.dt-df-box',
        placeholder: _vm.t('Name / Index / Ean')
      },
      "search-value": _vm.defaultFilter.search,
      "page-length": _vm.defaultFilter.pagination,
      "sort": false
    }
  }), _vm._v(" "), (_vm.type === 'group') ? _c('form-export', {
    attrs: {
      "active": this.config && this.config.isDumpActionActive,
      "action": _vm.$http.options.root + '/' + this.$route.name + '/dump',
      "filters": _vm.filters,
      "default-filter": _vm.defaultFilter
    }
  }) : _vm._e()], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2866c2c2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductStationaryAvailability/StationaryAvailability.vue
// module id = 1251
// module chunks = 2